import {Component, Inject, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {MatButton} from '@angular/material/button';

import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';

export class DialogData {
    title: string;
    message: string;
    acceptLabel: string;
    rejectLabel: string;
    multiline: boolean;
    preview: string | ArrayBuffer;
}

@Component({
    selector: 'frog-string-dialog',
    templateUrl: './string-dialog.component.html',
    styleUrls: ['./string-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatFormField,
        MatInput,
        ReactiveFormsModule,
        MatDialogActions,
        MatButton,
    ],
})
export class StringDialogComponent implements OnInit {
    public input: UntypedFormControl;

    constructor(
        public dialogRef: MatDialogRef<StringDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {
        this.input = new UntypedFormControl('');
    }

    ngOnInit(): void {}

    accept() {
        this.dialogRef.close(this.input.value);
    }

    reject() {
        this.dialogRef.close(null);
    }
}
